<template>
  <CModal
    size="xl"
    centered
    :closeOnBackdrop="false"
    :show.sync="modalVisible"
    addContentClasses="border-0 modal-border-radius"
  >
    <div slot="header" />
    <div slot="header-wrapper" />
    <div slot="body-wrapper">
      <closeButton :setModalVisible="setModalVisible" />
      <CContainer style="padding: 3.125rem">
        <CRow alignHorizontal="between" class="modal-title">
          <CCol>
            <div class="modal-title">Add a new Course</div>
          </CCol>
        </CRow>
        <CRow alignHorizontal="between" class="modal-detail">
          <CCol>
            <div class="input-label">Course's name</div>
            <template v-for="field of courseTemplate.name">
              <label :key="field">{{field.key}}</label>
              <input
                :key="field"
                v-model="field.val"
                placeholder="COURSE'S NAME"
                class="input input-text"
              />
            </template>
            <div
              @click="addANewField('name',getLanguage(courseTemplate.name.length))"
              class="button button-grey"
            >+</div>
          </CCol>
        </CRow>
        <CRow class="modal-detail">
          <CCol>
            <div class="input-label">Title</div>
            <template v-for="field of courseTemplate.title">
              <label :key="field">{{field.key}}</label>
              <input :key="field" v-model="field.val" placeholder="TITLE" class="input input-text" />
            </template>
            <div
              @click="addANewField('title',getLanguage(courseTemplate.title.length))"
              class="button button-grey"
            >+</div>
          </CCol>
        </CRow>
        <CRow class="modal-detail">
          <CCol>
            <div class="input-label">Subtitle</div>
            <template v-for="field of courseTemplate.subtitle">
              <label :key="field">{{field.key}}</label>
              <input
                :key="field"
                v-model="field.val"
                placeholder="SUBTITLE"
                class="input input-text"
              />
            </template>
            <div
              @click="addANewField('subtitle',getLanguage(courseTemplate.subtitle.length))"
              class="button button-grey"
            >+</div>
          </CCol>
        </CRow>
        <CRow class="modal-detail">
          <CCol>
            <div class="input-label">Objective</div>
            <template v-for="field of courseTemplate.objective">
              <label :key="field">{{field.key}}</label>
              <input
                :key="field"
                v-model="field.val"
                placeholder="OBJECTIVE"
                class="input input-text"
              />
            </template>
            <div
              @click="addANewField('objective',getLanguage(courseTemplate.objective.length))"
              class="button button-grey"
            >+</div>
          </CCol>
        </CRow>
        <CRow class="modal-detail">
          <CCol>
            <div class="input-label">Description</div>
            <template v-for="field of courseTemplate.description">
              <label :key="field">{{field.key}}</label>
              <input
                :key="field"
                v-model="field.val"
                placeholder="COURSE'S NAME"
                class="input input-text"
              />
            </template>
            <div
              @click="addANewField('description',getLanguage(courseTemplate.description.length))"
              class="button button-grey"
            >+</div>
          </CCol>
        </CRow>
        <CRow class="modal-detail">
          <CCol>
            <div class="input-label">Topics</div>
            <p>+</p>
          </CCol>
        </CRow>
        <CRow class="modal-detail">
          <CCol>
            <div class="input-label">Categorys</div>
            <p>+</p>
          </CCol>
        </CRow>
        <CRow class="modal-detail">
          <CCol>
            <div class="input-label">Study hour</div>
            <input type="number" class="input input-text" />
          </CCol>
        </CRow>
        <CRow class="modal-detail">
          <CCol>
            <div class="input-label">Carousels</div>
            <p>+</p>
          </CCol>
        </CRow>
        <CRow class="modal-detail">
          <CCol>
            <div class="input-label">Group</div>
            <p>+</p>
          </CCol>
        </CRow>
        <CRow class="modal-detail">
          <CCol>
            <div class="input-label">Enroll student</div>
            <p>+</p>
          </CCol>
        </CRow>
        <CRow class="modal-detail">
          <CCol>
            <div class="input-label">Controls</div>
            <p>+</p>
          </CCol>
        </CRow>
        <CRow class="modal-detail">
          <CCol>
            <div class="input-label">Enable</div>
          </CCol>
        </CRow>
        <CRow class="modal-detail">
          <CCol>
            <div class="input-label">Certificates</div>
          </CCol>
        </CRow>
        <CRow class="modal-detail">
          <CCol>
            <div class="input-label">Badges</div>
          </CCol>
        </CRow>
        <CRow class="modal-detail">
          <CCol>
            <div class="input-label">Levels</div>
            <select class="input input-select"></select>
          </CCol>
        </CRow>
        <CRow class="modal-detail">
          <CCol>
            <div class="input-label">Types</div>
          </CCol>
        </CRow>
        <CRow alignHorizontal="center">
          <div
            @click="setModalVisible()"
            class="button button-pink"
            style="margin-left: 0.9375rem; margin-right: 0.9375rem"
          >CANCEL</div>
          <div
            class="button button-green"
            style="margin-left: 0.9375rem; margin-right: 0.9375rem"
          >CONFIRM</div>
        </CRow>
      </CContainer>
    </div>
    <div slot="footer" />
    <div slot="footer-wrapper" />
  </CModal>
</template>

<script>
import closeButton from "../../modal/closeButton";
export default {
  name: "addANewCourseModal",
  props: {
    modalVisible: Boolean,
    setModalVisible: Function,
  },
  components: {
    closeButton,
  },
  data() {
    return {
      lang: ["en", "th"],
      courseTemplate: {
        code: String,
        name: [],
        title: [],
        subtitle: [],
        objective: [],
        description: [],
        topics: [],
        categorys: [
          {
            category: String,
          },
        ],
        studyHour: Number,
        carousels: [
          {
            type: Number,
            url: String,
            enable: Boolean,
          },
        ],
        groups: [
          {
            code: String,
            public: Boolean,
            instructors: [
              {
                instructor: "5ed9e68686103408a0343bb9",
                view: Boolean,
                edit: Boolean,
                delete: Boolean,
                enable: Boolean,
              },
            ],
          },
        ],
        views: [],
        favorites: [],
        enrolls: [],
        controls: {
          academicYear: String,
          semester: String,
          price: Number,
          order: Number,
        },
        enable: Boolean,
        create: {
          by: String, // User's account Id
        },
        certificates: [],
        badges: [],
        levels: {
          level: String, // level's id
        },
        types: [
          {
            type: String, // type's id
          },
        ],
      },
    };
  },
  methods: {
    getLanguage(position) {
      return this.lang[position];
    },
    addANewField(field, key) {
      this.courseTemplate[field].push({ key: key, val: null });
    },
  },
};
</script>

<style>
</style>